import {DefaultService as CommonService} from '../../services/DefaultService';
import {asyncThunkAction} from '../../utils/reduxThunkUtils';

/**
 * Calculate from with VAT
 */
export const calculateFromWithVat = asyncThunkAction(
  'common/calculateFromWithVat',
  CommonService.calculateFromWithVat
);

/**
 * Calculate from without VAT
 */
export const calculateFromWithoutVat = asyncThunkAction(
  'common/calculateFromWithoutVat',
  CommonService.calculateFromWithoutVat
);
